import { useState, FC } from 'react';
import Alert from '@mui/material/Alert';
import { useSnackbar } from 'notistack';
import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Fade, ButtonGroup, Button, Grid, Typography } from '@mui/material';
import { Close, Restore } from '@mui/icons-material';
import { Modal, Loader } from '../../../components';
// import { resetBuild } from '../../../fetch';
import { INeighborhood } from '../../../models';
import { deletePreWalkData, deletePunchListData } from '../../../fetch/jobs';

interface IDeletePunchListModal {
  neighborhood: INeighborhood;
  lotNumber: number;
  punchOrPre: any;
  open: boolean;
  onClose: () => void;
  onResetForm: () => void;
}

export const DeletePunchListModal: FC<IDeletePunchListModal> = ({
  open,
  onClose,
  onResetForm,
  neighborhood,
  lotNumber,
  punchOrPre
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isDeleting, setDeleting] = useState(false);
  return (
    <Modal open={open} onClose={onClose} maxWidth="sm">
      <Fade in={open}>
        <div>
          {isDeleting && (
            <Loader position="centered" type="overlay">
              Deleting...
            </Loader>
          )}
          <Box marginBottom="1rem">
            {' '}
            {neighborhood && (
              <Typography variant="h5">
                Delete {punchOrPre} data for {neighborhood.neighborhoodId} - {neighborhood.name} for{' '}
                {lotNumber ? `lot ${lotNumber}` : 'all lots'}
              </Typography>
            )}
          </Box>
          <Alert severity="warning">
            This function will DELETE data and that data can not be recovered. So be very careful
            when using this function.
          </Alert>
          <Grid container alignItems="center" className={classes.saveWrapper}>
            <ButtonGroup>
              <Button
                id="reset"
                className={classes.resetButton}
                variant="contained"
                disabled={isDeleting}
                startIcon={<Restore />}
                onClick={async () => {
                  setDeleting(true);
                  try {
                    // await resetBuild(currentBuild.buildId);
                    if (punchOrPre === 'puchlist') {
                      await deletePunchListData(neighborhood.neighborhoodId, lotNumber);
                    } else {
                      await deletePreWalkData(neighborhood.neighborhoodId, lotNumber);
                    }
                    enqueueSnackbar(
                      `${punchOrPre.charAt(0).toUpperCase() + punchOrPre.slice(1)} data deleted!`,
                      {
                        variant: 'success'
                      }
                    );
                    onClose();
                    onResetForm();
                  } catch (error) {
                    enqueueSnackbar('Error deleting data, please try again.', {
                      variant: 'error'
                    });
                  } finally {
                    setDeleting(false);
                  }
                }}
              >
                Delete
              </Button>
              <Button id="cancel" variant="contained" startIcon={<Close />} onClick={onClose}>
                Cancel
              </Button>
            </ButtonGroup>
          </Grid>
        </div>
      </Fade>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  saveWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1)
  },
  resetButton: {
    backgroundColor: theme.palette.warning.main,
    color: '#fff'
  }
}));
